<script lang="ts" context="module">
  export const schema = cloneDeep(RichTextSchema);

  export const resolver = new RichTextResolver(schema);

  export const hasRichTextContent = (doc: ISbRichtext | undefined) => {
    return (
      doc &&
      doc.type === 'doc' &&
      doc.content &&
      doc.content.length > 0 &&
      // storyblok sometimes sends just an empty paragraph
      !(doc.content.length === 1 && doc.content[0].type === 'paragraph' && !doc.content[0].content)
    );
  };
</script>

<script lang="ts">
  import cloneDeep from 'clone-deep';
  import { RichTextResolver, type ISbRichtext, RichTextSchema } from '@storyblok/js';

  import { cn } from '$lib/utils';

  import type { HTMLAttributes } from 'svelte/elements';

  import GreenCircle from '$components/blocks/rich-text-addons/green-circle.svelte';
  import PinkUnderline from '$components/blocks/rich-text-addons/pink-underline.svelte';
  import YellowUnderline from '$components/blocks/rich-text-addons/yellow-underline.svelte';
  import type { TitleColorfulStoryblok } from '$types/bloks';

  type $$Props = HTMLAttributes<HTMLDivElement> & {
    block: TitleColorfulStoryblok;
    as?: string;
  };

  export let block: $$Props['block'];
  let className: $$Props['class'] = undefined;
  export { className as class };

  $: doc = block?.title;
</script>

{#if doc && doc.type === 'doc' && doc.content?.length && hasRichTextContent(doc)}
  <section class={cn('px-2 lg:px-8 py-8 ', className)}>
    <div class={'richtext container mx-auto'}>
      {#each doc.content as section}
        {#if section && section.type === 'paragraph' && section.content?.length}
          {#each section.content as item}
            {@const marks = item.marks?.map((mark) => mark?.type)}
            {@const text = item.text?.trim()}
            {#if text}
              {#if !(marks?.includes('bold') || marks?.includes('underline') || marks?.includes('italic'))}
                {#if text}
                  {#each text.split(' ') as word}
                    <p class="inline-block text-5xl font-medium leading-[112%] z-10 relative">
                      {word}&nbsp;
                    </p>
                  {/each}
                {/if}
              {:else}
                <p class="relative inline-block text-5xl font-medium leading-[112%]">
                  {#if marks?.includes('bold')}
                    <GreenCircle
                      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0 h-[160%]"
                    />
                  {/if}
                  {#if marks?.includes('underline')}
                    <PinkUnderline class="absolute top-[45%] left-0  z-0 w-[120%] h-[40%]" />
                  {/if}
                  {#if marks?.includes('italic')}
                    <YellowUnderline class="absolute top-[45%] left-0  z-0  w-[120%] h-[40%]" />
                  {/if}

                  <span class="relative z-10">{text}&nbsp</span>
                </p>{/if}
            {/if}
            {#if item && item.type === 'hard_break'}
              <br />
            {/if}
          {/each}
        {/if}
      {/each}
    </div>
  </section>
{/if}
